export default "__VITE_ASSET__SjwOa8zE__"